"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMarketQuotes = void 0;
const react_1 = require("react");
/**
 * Served by netlify/functions/eua.mjs. It has to be fetched through our own
 * origin: every public EUA source we can reach either sends no CORS headers or
 * sits behind a bot challenge. On a plain static preview this path 404s and the
 * form simply keeps its fallback figure.
 */
const EUA_SRC = "/api/eua";
const FX_SRC = [
    "https://api.frankfurter.dev/v1/latest?base=EUR&symbols=USD",
    "https://open.er-api.com/v6/latest/EUR",
];
const CHECKING = { eua: "checking", fx: "checking" };
const getText = async (url) => {
    const response = await fetch(url, { cache: "no-store" });
    if (!response.ok)
        throw new Error(String(response.status));
    return response.text();
};
const loadEua = async () => {
    const { price } = JSON.parse(await getText(EUA_SRC));
    if (typeof price !== "number" || !isFinite(price) || price <= 0) {
        throw new Error("bad");
    }
    return price;
};
const pickUsd = (text) => {
    const rate = JSON.parse(text).rates?.USD;
    if (!isFinite(rate))
        throw new Error("bad");
    return rate;
};
const loadFx = async () => {
    try {
        return pickUsd(await getText(FX_SRC[0]));
    }
    catch {
        return pickUsd(await getText(FX_SRC[1]));
    }
};
/**
 * Pulls an indicative front-month EUA quote and the EUR/USD reference rate.
 * Whatever fails simply keeps the fallback figure already in the form.
 */
const useMarketQuotes = (onQuotes) => {
    const [status, setStatus] = (0, react_1.useState)(CHECKING);
    const onQuotesRef = (0, react_1.useRef)(onQuotes);
    (0, react_1.useEffect)(() => {
        onQuotesRef.current = onQuotes;
    });
    const run = (0, react_1.useCallback)(() => {
        void loadEua().then((price) => {
            onQuotesRef.current({ eua: price });
            setStatus((prev) => ({ ...prev, eua: "live" }));
        }, () => setStatus((prev) => ({ ...prev, eua: "stale" })));
        void loadFx().then((rate) => {
            onQuotesRef.current({ fx: Math.round(rate * 10000) / 10000 });
            setStatus((prev) => ({ ...prev, fx: "live" }));
        }, () => setStatus((prev) => ({ ...prev, fx: "stale" })));
    }, []);
    // The first look-up runs on mount; "checking" is already the initial state.
    (0, react_1.useEffect)(() => {
        run();
    }, [run]);
    const refresh = (0, react_1.useCallback)(() => {
        setStatus(CHECKING);
        run();
    }, [run]);
    return { status, refresh };
};
exports.useMarketQuotes = useMarketQuotes;
